/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
import { AxiosError } from 'axios';
import { isAxiosError, isFailedAxiosRequest } from '../api';
import _isFunction from 'lodash/isFunction';
import { DtrumApi } from '@dynatrace/dtrum-api-types';

interface NewRelicCustomAttributes
  extends Partial<Record<string, string | number>> {
  hookName?: string;
  componentName?: string;
  methodName?: string;
}

export function logErrorIfRequestFailed(
  err: AxiosError | Error | string,
  customAttributes: NewRelicCustomAttributes = {}
): void {
  if (isFailedAxiosRequest(err)) {
    logError(err, customAttributes);
  }
}

export function logError(
  err: AxiosError | Error | string,
  customAttributes: NewRelicCustomAttributes = {}
): void {
  // Log to Browser Console
  console?.error(err, customAttributes);

  if (isAxiosError(err)) {
    // Decorate `customAttributes` with response status and response body from Axios
    if (err.response) {
      customAttributes.apiResponseStatus = err.response.status;
      customAttributes.apiResponseBody = err.response.data
        ? JSON.stringify(err.response.data)
        : 'No data';
    }
  }

  // Log to New Relic
  window.newrelic?.noticeError(err, customAttributes);
}

export function logDynatraceError(error: Error): void {
  console?.error(error);
  const dtrum: DtrumApi | undefined = window.dtrum;

  if (!dtrum || !_isFunction(dtrum.reportError)) {
    return;
  }

  dtrum.reportError(error as Error);
}
